module.exports = {"outlet":"Outlet Staff"};


//////////////////
// WEBPACK FOOTER
// ./resources/lang/en/staff.php
// module id = 49be
// module chunks = 86